import type { FC } from 'react';
import { formatMoney, formatMonthDayYear } from '../../../../utils/utils';
import QueryGuard from '../../../../Components/QueryGuard';
import Table from '../../../../Components/Table';
import { useNavigate } from 'react-router-dom';
import { CustomerPackagesQueryResult, useCustomerPackagesQuery } from './graphql/customerPackages.generated';

interface Props {
  customerId: string;
}

const CustomerPackages: FC<Props> = ({ customerId }) => {
  const navigate = useNavigate();
  const { data, error, loading } = useCustomerPackagesQuery({ variables: { customerIds: [customerId] } });

  const renderBookingTable = (packages: CustomerPackagesQueryResult['getPackages']) => {
    const tableData = packages?.map((customerPackage) => ({
      data: {
        name: customerPackage?.packageName ? customerPackage.packageName : 'Package',
        totalAmount: customerPackage.customerPayment?.total?.amount
          ? formatMoney(customerPackage.customerPayment.total.amount)
          : '-',
        createdBy: customerPackage.createdBy
          ? `${customerPackage.createdBy.firstName} ${customerPackage.createdBy.lastName}`
          : '-',
        createdAt: customerPackage.createdAt ? formatMonthDayYear(+customerPackage.createdAt) : '-'
      },
      onRowClick: () => navigate(`/packages/${customerPackage.id}`)
    }));

    return <Table tableData={tableData} />;
  };

  return (
    <QueryGuard data={data && data.getPackages} loading={loading} error={error ? !!error : false} displayNoResult={false}>
      {data && data.getPackages && (
        <div>
          <h2 className="text-lg font-bold my-4">Packages</h2>
          <div>{renderBookingTable(data.getPackages)}</div>
        </div>
      )}
    </QueryGuard>
  );
};

export default CustomerPackages;
